import React from 'react';
import { Typography, Card, Row, Col } from 'antd';
import IndividualInformHeader from '../components/individualInformHeader/individualInformHeader';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';

const { Title, Paragraph, Text } = Typography;

const EmptyListMessage = ({ text }) => (
    <Text style={{ fontSize: '11px' }}>{text}</Text>
);

const PageOportunitiesStrenghtsIndividual = ({
    individualResult,
    selectedEvaluation,
    orgLogo,
    pageNumber,
    data,
    sectionType = 'all',
}) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const renderList = (items, emptyText) => {
        if (!items?.length) return <EmptyListMessage text={emptyText} />;

        return (
            <ul>
                {items.map((item, idx) => (
                    <li style={{ fontSize: '11px' }} key={idx}>{item}</li>
                ))}
            </ul>
        );
    };

    const cardsBySection = {
        strengths: [
            {
                title: 'Fortalezas Confirmadas',
                description: 'Son aquellos atributos en los cuales tanto las personas que lo calificaron como usted asignaron una puntuación igual o mayor al mínimo esperado establecido para el cargo. Los evaluadores y usted reconocen como una fortaleza.',
                items: data.fortalezas_conocidas,
                emptyText: 'No se identifican fortalezas confirmadas en la medición actual.',
            },
            {
                title: 'Fortalezas Desconocidas',
                description: 'Son aquellos atributos en los cuales las personas que lo calificaron puntuaron igual o por encima del mínimo esperado, mientras usted se calificó por debajo de dicho límite. Los evaluadores las conocen como una fortaleza.',
                items: data.fortalezas_desconocidas,
                emptyText: 'No se identifican fortalezas desconocidas en la medición actual.',
            },
        ],
        opportunities: [
            {
                title: 'Áreas De Mejoramiento Confirmadas',
                description: 'Son aquellos atributos en los cuales tanto las personas que lo calificaron como usted asignaron una puntuación inferior al mínimo esperado establecido para el cargo. Usted concuerda con el resto de los evaluadores en que son oportunidades de mejora que deben ser tenidas en cuenta para mejorar su desempeño del cargo.',
                items: data.oportunidades_conocidas,
                emptyText: 'No se identifican áreas de mejoramiento confirmadas en la medición actual.',
            },
            {
                title: 'Áreas De Mejoramiento Desconocidas',
                description: 'Son aquellos atributos en los cuales las personas que lo calificaron puntuaron por debajo del mínimo esperado, mientras usted se calificó por encima de dicho límite. Es una oportunidad de mejora en un área que usted considera que estaba cumpliendo con las expectativas del cargo.',
                items: data.oportunidades_desconocidas,
                emptyText: 'No se identifican áreas de mejoramiento desconocidas en la medición actual.',
            },
        ],
    };

    const selectedCards = cardsBySection[sectionType] || [
        ...cardsBySection.strengths,
        ...cardsBySection.opportunities,
    ];

    const pageTitle = sectionType === 'strengths'
        ? 'Fortalezas'
        : sectionType === 'opportunities'
            ? 'Oportunidades de mejora'
            : 'Fortalezas y oportunidades de mejora';

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info" style={{ position: "relative" }}>
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />
                    <Card
                        style={{
                            border: 'none',
                            backgroundColor: 'white',
                            boxShadow: 'none',
                        }}
                        styles={{ body: { padding: '0' } }}
                    >
                        <Title
                            level={4}
                            style={{ color: '#339C98', marginBottom: 16, width: 'calc(100% - 150px)' }}
                        >
                            {pageTitle}
                        </Title>
                        <Row gutter={[16, 16]}>
                            {selectedCards.map((card) => (
                                <Col xs={24} md={12} key={card.title}>
                                    <Card bordered={false} style={{ height: '100%', background: '#f9fcff', padding: '0 !important' }}>
                                        <Text style={{ color: '#2a3b8d', fontWeight: 'bold' }}>
                                            {card.title}
                                        </Text>
                                        <Paragraph style={{ marginTop: 5, fontSize: 11 }}>
                                            {card.description}
                                        </Paragraph>
                                        {renderList(card.items, card.emptyText)}
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Card>
                    <div style={{marginTop: "15px", fontSize: "10px", color: "#666", textAlign: "justify"}}>
                        <i>* Nota: La clasificación en estos cuadrantes se basa en la comparación entre su autoevaluación y el promedio de las evaluaciones de terceros, tomando como referencia los umbrales de meta esperada predefinidos en el modelo. Una mayor brecha refleja la diferencia en la percepción del desempeño u oportunidad de mejora evidenciada.</i>
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageOportunitiesStrenghtsIndividual;
